import { Component } from '@angular/core';

@Component({
  selector: 'app-wire-wiring-harness',
  templateUrl: './wire-wiring-harness.component.html',
  styleUrls: ['./wire-wiring-harness.component.scss']
})
export class WireWiringHarnessComponent {
  advanceMoullding:any[] = [
    {
      //title: 'Rubber Extrusion​​',
      img: 'assets/images/capability/white/wire_harness_1.JPG',
    },
    {
      //title: 'Cryogenic Deflashing​',
      img: 'assets/images/capability/white/wire_harness_2.JPG',
    },
    {
      //title: 'Metal To Rubber Parts',
      img: 'assets/images/capability/white/wire_harness_3.JPG',
    },
    {
      //title: 'Elastomer Calendering​',
      img: 'assets/images/capability/white/wire_harness_4.JPG',
    },
    {
      //title: 'Elastomer Moulding',
      img: 'assets/images/capability/white/wire_harness_5.JPG',
    },
    {
      //title: 'Plastic To Rubber Bonding​',
      img: 'assets/images/capability/white/wire_harness_6.JPG',
    }
  ]
  produtData:any[] = [
    {
      title: 'Rubber Extrusion',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Elastomer Moulding​​',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Cryogenic Deflashing​',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Metal to Rubber Parts​​​',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Plastic to Rubber Bonding',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Elastomer Calendering​​',
      img: 'assets/images/placeholder.jpg',
    }
  ]  
  materialExpertise:any[] = [
    { 'item': 'Serving a global customer base with over 102 facilities spread across 21 countries globally'},
    // { 'item': 'ABS'},
    // { 'item': 'Nylon'},
    // { 'item': 'PC'},
    // { 'item': 'PBT'},
    // { 'item': 'PMMA'},
    // { 'item': 'Other Engineering Plastic'},
  ]
  sizeandprecision:any[] = [
    { 'item': 'Passenger Cars'},
    { 'item': 'Two-wheelers and recreational vehicles'},
    { 'item': 'Agricultural machines'},
    { 'item': 'Commercial vehicles (heavy, medium and light-duty)'},
    { 'item': 'Rolling stock (trains, trams, locomotives, electrical buses)'},
    { 'item': 'Construction and material handling equipment'},
    { 'item': 'Other industrial applications such as medical diagnostic equipment, white goods, office automation'},
  ]
  advancemouldingtechnique:any[] = [
     { 'item':'Electrical Distribution Systems'},
     { 'item':'Components such as Wires, Terminals, Connectors, Fuse Boxes, Seals etc.'},
     { 'item':'Power Modules'},
     { 'item':'Electrical cabinets and power packs'},
    //  { 'item':'Thermoforming'},
    //  { 'item':'Compression Moulding'}
  ]
  inhousetech:any[] = [
    { 'item':'Manufacturing Feasibility'},
    { 'item':'Prototyping'},
    { 'item':'Tool Designing'},
    { 'item':'Tool Manufacturing'},
    { 'item':'Moulding'},
    { 'item':'Prototyping'}
 ]
}
